import React from 'react'
import tabla from '../../tabla.png'
import Infoblokk from '../../infoblokk.jpg'

const Tender = () => {
    const theme = {
    darkSlate: '#1e293b',
    constructionOrange: '#f97316',
    lightGrey: '#f1f5f9',
    white: '#ffffff',
  };
  return (
         <section className="section" id="palyazat" style={{ backgroundColor: theme.white }}>
    <div className="container">
      <div className="columns is-centered">
        <div className="column is-10 has-text-centered">
          <h2 className="title is-3" style={{ color: theme.darkSlate }}>Nyertes Pályázatunk</h2>
          <div 
            style={{ width: '60px', height: '4px', backgroundColor: theme.constructionOrange, margin: '0 auto 2rem auto' }}
          ></div>
          <p className="mb-5" style={{ color: theme.darkSlate }}>
            A Széchenyi Terv Plusz program keretében megvalósuló projektünk részletei.
          </p>
          
          {/* Pályázati kép helye */}
          <figure className="image is-inline-block mb-6" style={{ border: `2px solid ${theme.darkSlate}`, borderRadius: '8px', overflow: 'hidden', boxShadow: '0 4px 6px rgba(0,0,0,0.1)' }}>
            <img 
              src={Infoblokk} 
              alt="Széchenyi Terv Plusz Információs Tábla" 
              style={{ maxWidth: '100%', height: 'auto', display: 'block' }}
            />
          </figure>

          {/* Kötelező szöveges elemek a GINOP Plusz arculati kézikönyv szerint */}
          <div className="content has-text-left" style={{ 
            color: theme.darkSlate, 
            maxWidth: '800px', 
            margin: '0 auto', 
            backgroundColor: '#f9f9f9', /* Halvány háttér kiemeli a blokkot */
            padding: '2rem', 
            borderRadius: '8px',
            boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
          }}>
            <h3 className="title is-4 mb-4" style={{ color: theme.darkSlate }}>Sajtóközlemény</h3>
            <div><strong>Vállalkozásfejlesztés a Sz. és Sz. Center Bt-nél</strong></div>
            <div>2025/12/16</div>
            <br/>
            <div>Az Európai Unió és a Magyar Állam által nyújtott támogatással valósul meg fejlesztés az Sz. és Sz. Center Bt-nél. A projekt a Széchenyi Terv Plusz program keretében valósul meg. A Gazdaságfejlesztési és Innovációs Operatív Program Plusz keretében 11,75 millió Ft vissza nem térítendő támogatást nyert a cég üzleti és működési feltételeinek javítása céljából. <br/><br/>A fejlesztés eredményeként a cég tevékenysége hatékonyabbá, fenntarthatóbbá és versenyképesebbé válik egy nagy teljesítményű, korszerű mini kotrógép beszerzésével, valamint egy felhőalapú CRM rendszer bevezetésével, ezáltal erősítve piaci pozícióját. A tervezett fejlesztésekkel a projekt hozzájárul a GINOP Plusz program kitűzött céljainak eléréséhez, ezáltal a cég gazdaságban betöltött szerepének, piaci pozíciójának erősítéséhez, valamint a területi különbségek csökkentéséhez, a térségi felzárkóztatás és a helyi gazdaság megerősítéséhez. A fejlesztés alapvető célja a GINOP Plusz 1.2.4-25 felhívása alapján a Mikro- és kisvállalkozások támogatása a leghátrányosabb helyzetű régiókban, illetve a Szabad Vállalkozási Zónákban. A pályázati felhívás forrását az Európai Regionális Fejlesztési Alap és Magyarország költségvetése társfinanszírozásban biztosítja.</div>
            <ul style={{ listStyleType: 'none', marginLeft: 0, paddingLeft: 0 }}>
              <li className="mb-2"><strong>A projekt összegző adatai:</strong></li>
              <li className="mb-2"><strong>Kedvezményezett:</strong> Sz. és Sz. Center Betéti Társaság</li>
              <li className="mb-2"><strong>Projekt címe:</strong> Vállalkozásfejlesztés az Sz. és Sz. Center Bt-nél</li>
              <li className="mb-2"><strong>Projekt azonosító száma:</strong> GINOP_PLUSZ-1.2.4-25-2025-01020</li>
              <li className="mb-2"><strong>Támogatás összege:</strong> 11 745 925 Ft</li>
              <li className="mb-2"><strong>A projekt megvalósítási helyszíne:</strong> 6500 Baja, Szegedi út 112., hrsz.: 12394</li>
              <li className="mb-2"><strong>Tervezett fizikai befejezés dátuma:</strong> 2026.12.31.</li>
            </ul>
            <div>A fejlesztés a Széchenyi Terv Plusz program GINOP_PLUSZ-1.2.4-25 kódszámú „Mikro- és kisvállalkozások támogatása a leghátrányosabb helyzetű régiókban, illetve a Szabad Vállalkozási Zónákban támogatása” című pályázat keretében valósul meg az Európai Unió támogatásával, a magyar állam társfinanszírozásával.</div>
          </div>

        </div>
      </div>
    </div>
  </section>
  )
}

export default Tender